import React,{useState} from "react";
import {
  Container,
  Typography,
  Box,
  Grid,
  Button,
  TextField,CardMedia,
} from "@mui/material";
import OfferCards from "./OfferCards";
import { offerarray } from "./Offerarray";
const Offer = (props) => {
    const [search, setSearch]=useState("")
  return (
    <React.Fragment>
      <Typography
        sx={{
          background: `linear-gradient(#212245b2,#212245b2),url("offer.avif")`,
          textAlign: "center",
          backgroundRepeat: "no-repeat",
          padding: "80px ",
          backgroundSize:"cover",
          backgroundPosition: "center",
          height: "120px",
          color: "white",
          fontSize: "1.8rem",mt:8
        }}
      ><Typography sx={{fontSize:"2rem"}}>Special Offer</Typography>
        Get Offer upto <span style={{fontSize:"3.8rem"}}>20%</span>
        
      </Typography>
      <Container>
        <Box sx={{mt:5}}>
          <Typography sx={{ fontSize: "1.5rem", textAlign: "center", }}>
            Limited time offer, Hurry up!
          </Typography>
         
        </Box>
        <Grid container spacing={5}>
         {
           offerarray.map((item,index)=>( <Grid item lg={3} md={4} xs={12}>
         
            <OfferCards key={index}
               item={item}
                img={item.image}
                name={item.name}
                price={item.price}
                description={item.description}
                size1={item.size1}
                size2={item.size2}
                size3={item.size3}
                price2={item.price2}
                brand={item.brand}
                color1={item.color1}
                color2={item.color2}
                discount={item.discount}
                id={item.id}
             />
      
            </Grid>))
         }
         
        
        </Grid>
      </Container>
    </React.Fragment>
  );
};

export default Offer;
